const UkraineFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="10" fill="#005BBB"/>
    <rect y="10" width="30" height="10" fill="#FFD500"/>
  </svg>
);

export default UkraineFlag;